import { useLoginByAuto } from "@/api/clientApi/login";
import { LocalStorageKey } from "@/constants/constants";
import { useActivity } from "@/hooks/useActivity";
import { useRepeatActivityContainBasic } from "@/hooks/useRepeatActivityContainBasic.ts";
import { getLocalStorageItem, setLocalStorageItem } from "@/lib/localStorage";
import { sdkManager } from "@/lib/sdk/sdkManager";
import { ThinkingDataSDK } from "@/lib/sdk/thinkingData";
import { SDKName } from "@/lib/sdk/types";
import { requestSaveSubscription } from "@/lib/subscribe";
import { isEmptyObject } from "@/lib/utils";
import { getActivityCfg } from "@/stores/activityStore.ts";
import {
  getShareTextConfig,
  getUserShareUrl,
} from "@/stores/affiliateStore.ts";
import { getDeviceObject } from "@/stores/deviceStore";
import {
  getAgentRewardDotData,
  getUserInfo,
  userStore,
} from "@/stores/userStore";
import { reconnectWS, reportEvent } from "@/stores/websocketStore";
import { ActivityTypeEnum } from "@/types/compontent/base/baseEnum.ts";

import { useBounsCenterInit } from "../bonusCenter/useBounsCenterInit";
import { useAutoLogin } from "../useAutoLogin";

export const useAfterLogin = () => {
  const { initData } = useBounsCenterInit();
  const { isAutoLogin, bChangeToken } = useAutoLogin();

  const { getAllRepeatCfg } = useActivity();
  const dealAfterLogin = () => {
    let isReqAutoLogin = false;
    const lastLoginTime = getLocalStorageItem(LocalStorageKey.LastLoginTime, 0);
    const lastLoginDate = new Date(lastLoginTime);
    const deviceNow = getDeviceObject();
    const now = new Date();
    const nowTime = now.getTime();
    setLocalStorageItem(LocalStorageKey.LastLoginTime, nowTime);

    if (now.getDate() !== lastLoginDate.getDate()) {
      // 每天第一次登录
      if (isAutoLogin()) {
        isReqAutoLogin = true;
        if (deviceNow.app && lastLoginTime == 0) {
          isReqAutoLogin = false;
        }
      }
    }

    if (isAutoLogin()) {
      const clientDevice = getLocalStorageItem(
        LocalStorageKey.ClientDevice,
        {},
      );

      if (JSON.stringify(clientDevice) != JSON.stringify(deviceNow)) {
        isReqAutoLogin = true;
        if (deviceNow.app && isEmptyObject(clientDevice)) {
          isReqAutoLogin = false;
        }
      }
    }

    if (isReqAutoLogin) {
      const uid = userStore.userInfo?.uid;
      const token = userStore.token;
      const hasChangedToken = bChangeToken();
      if (uid && token) {
        useLoginByAuto({
          uid: uid,
          token: token,
          new_login: hasChangedToken,
        });
      }
      // TODO: 处理自动登录请求
    } else {
      if (isAutoLogin()) {
        // 自动登录
        const lastLoginEventTime = getLocalStorageItem(
          LocalStorageKey.LastLoginEventTime,
          0,
        );
        const timeGap = nowTime - lastLoginEventTime;
        if (timeGap > 30 * 60 * 1000) {
          // 30分钟间隔
          setLocalStorageItem(LocalStorageKey.LastLoginEventTime, nowTime);
          // TODO: 发送登录事件
          // googleEvent({ sendType: 0, event: "login", event_type: "af_login" });
        }
      }
    }
  };

  const afterLoginSuccess = () => {
    setTimeout(async () => {
      try {
        if (!document.body || !document.head) return;

        reconnectWS();
        initData();
        dealAfterLogin();
        reportEvent();
        getAllRepeatCfg(); // 获取优惠活动
        sdkManager.reportHjUserProperties();
        await getUserInfo(true);
        sdkManager
          .getSDK<ThinkingDataSDK>(SDKName.ThinkingDataSDK)
          ?.login(userStore.userInfo?.uid?.toString() ?? "");
        // 登录成功后获取联盟计划奖励红点
        getAgentRewardDotData();
        requestSaveSubscription();

        getUserShareUrl();
        getShareTextConfig();

        const webToFirstDepositAppCfg = getActivityCfg(
          ActivityTypeEnum.appdownload,
        )?.cfg;
        if (
          webToFirstDepositAppCfg?.pop_ups_type === 3 &&
          userStore.userInfo?.is_pay
        ) {
          useRepeatActivityContainBasic().getWebToAppActivityAward();
        }
      } catch (error) {
        console.error("Error in afterLoginSuccess:", error);
      }
    });
  };

  return { afterLoginSuccess };
};
